import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import type { PermissionCatalogEntry } from "./useRoleEditor";
import type { Permission } from "../../auth/HasPermission";
import { groupByGroup } from "./GroupByGroup";

interface PermissionCheckboxGroupProps {
  catalog: PermissionCatalogEntry[];
  selected: Set<Permission>;
  disabled: boolean;
  onToggle: (permission: Permission) => void;
}

export interface GroupedPermissions {
  group: string;
  entries: PermissionCatalogEntry[];
}

export function PermissionCheckboxGroup({ catalog, selected, disabled, onToggle }: PermissionCheckboxGroupProps) {
  const groups = groupByGroup(catalog);
  return (
    <Box>
      {groups.map((group) => (
        <Box key={group.group} sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            {group.group}
          </Typography>
          <Stack spacing={1}>
            {group.entries.map((entry) => (
              <FormControlLabel
                key={entry.name}
                control={<Checkbox checked={selected.has(entry.name)} disabled={disabled} onChange={() => onToggle(entry.name)} />}
                label={
                  <Box>
                    <Typography variant="body2">{entry.name}</Typography>
                    <Typography variant="caption" color="text.secondary" component="div">
                      {entry.description.backend}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" component="div">
                      {entry.description.frontend}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Box>
  );
}
